import $ from "jquery";

/////// for switching between pages ///////

$(".nav-mobile .menu-box").click(function () {
    let $navigation = $(".nav-mobile .navigation");
    if ($navigation.data('show') === true) {
        $navigation.css({
            right: '-100%'
        });
        $navigation.data('show', false);
    } else {
        $navigation.css({
            right: 0
        });
        $navigation.data('show', true);
    }
});

$('.logo').click(function () {
    $("html, body").animate({scrollTop: 0}, "slow");
    return false;
});

$('.js-downloadQrcode').qrcode({
    render: 'canvas',
    size: 90,
    ecLevel: 'H',
    text: 'https://tweebaa.cn/download.html'
});

/////// for switching between pages ///////
